











































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import report from '@/components/data/report.vue';
import { searchByName } from '@/api/common';
import moment from 'moment';
import { voteRawColumns } from '@/utils/report';
import { getCommonList } from '@/api/common';
import { meetingGoalMap } from '@/utils/meeting';
import { roundList } from '@/api/round.js';
import { getICList } from '@/api/common.js';

const url = '/projectVote/getVoteReports';
const downloadUrl = '/projectVote/downloadVoteReports';

@Component({
  components: { report }
})
class VoteRawReport extends Vue {
  voteRawColumns: any[] = voteRawColumns;
  projectName: string = '';
  currency: number = 0;
  meetingGoal: number = 0;
  roundId: number = 0;
  url: string = url;
  endTime: string = '';
  startTime: string = '';
  downloadUrl: string = downloadUrl;
  fileName: string = '';
  columns: any[] = voteRawColumns;
  industry: string = '';
  projectNameTmp: string = '';
  currencyList: any[] = [
    {
      name: '全部币种',
      value: 0
    },
    {
      name: '人民币',
      value: 1
    },
    {
      name: '美元',
      value: 2
    },
    {
      name: '人民币及美元',
      value: 3
    }
  ];
  roundList: any[] = [];
  meetingGoalMap: any = {
    ...meetingGoalMap,
    0: '全部会议类型'
  };

  get requestData() {
    // meetingGoal roundId endTime startTime companyName page pageSize
    const { meetingGoal, projectName, startTime, endTime, roundId } = this;
    let data = {
      meetingGoal,
      roundId,
      projectName,
      startTime,
      endTime
    };
    for (let key in data) {
      console.log(key,data[key]);
      
      if (!data[key]) {
        delete data[key];
      }
    }
    console.log(data);
    
    return data;
  }

  created() {
    this.getRoundList();
    this.getICList();
  }

  mounted() {
    let date = moment(new Date()).format('YYYYMMDD');
    this.fileName = `Vote原始数据报表_${date}`;
  }

  handleSearch(val) {
    this.projectName = val;
  }

  onChange(date, dateString) {
    this.endTime = date ? moment(date).endOf('d').format('YYYY-MM-DD HH:mm:ss') : '';
    if (this.projectNameTmp !== this.projectName) {
      this.projectName = this.projectNameTmp;
    }
  }
  startOnChange(date, dateString) {
    this.startTime = date ? moment(date).startOf('d').format('YYYY-MM-DD HH:mm:ss') : '';
    if (this.projectNameTmp !== this.projectName) {
      this.projectName = this.projectNameTmp;
    }
  }

  currencyChange() {
    if (this.projectNameTmp !== this.projectName) {
      this.projectName = this.projectNameTmp;
    }
  }

  async getRoundList() {
    try {
      let res = await roundList();
      if (res.code === 200) {
        this.roundList = [
          {
            id: 0,
            name: '全部轮次'
          }
        ].concat(res.data);
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getICList(flag = false) {
    try {
      let res = await getICList();
      if (res.code === 200) {
        let ICList = res.data.map(_ => {
          return {
            'title': _.nickname,
            'key': _.nickname,
            'dataIndex': _.nickname,
            'width': '100px'
          };
        });
        this.columns = this.voteRawColumns.concat(ICList);
      }
    } catch (err) {
      console.log(err);
    }
  }
}
export default VoteRawReport;
